import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import style from "../../sass/pages/auth/auth-page.module.scss";
import { setPathToProfile, setPathToRegistration } from "../path/pathSlice";
import {
    authenticationThunk,
    selectAuthenticated,
    selectAuthenticationError,
} from "./authSlice";
import { pushAlert } from "../alerts/alertSlice";
import { validateEmail } from "./validates";
import { setRegistrated } from "../registration/registrationSlice";
import { useTranslation } from "react-i18next";
import { checkIsAdmin } from "../admin/adminSlice";

const AuthenticationPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authenticated = useSelector(selectAuthenticated);
    const error = useSelector(selectAuthenticationError);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleButtonClick = async () => {
        let emailErr = validateEmail(email);
        let errors = [];

        if (emailErr) {
            errors.push(emailErr);
        }

        if (errors.length > 0) {
            errors.forEach((err) => {
                dispatch(
                    pushAlert({
                        type: "danger",
                        message: t(err),
                        delay: 2000,
                    })
                );
            });
            return;
        }

        dispatch(
            authenticationThunk({
                email,
                password,
            })
        );
    };

    useEffect(() => {
        if (!authenticated) {
            return;
        }
        dispatch(setPathToProfile());
        dispatch(checkIsAdmin())
    }, [authenticated, dispatch, navigate]);

    useEffect(() => {
        if (!error) {
            return;
        }
        dispatch(
            pushAlert({
                message: t(error),
                delay: 1000,
                type: "danger",
            })
        );
    }, [dispatch, error]);

    const redirectToRegistration = () => {
        dispatch(setRegistrated(false));
        dispatch(setPathToRegistration());
    };

    return (
        <div className={style.container}>
            <main className={style.main}>
                <div className={style.imageBlock}>
                    <img src="/static/images/png/profile-image.png" alt="" />
                </div>

                <div className={style.rightBlock}>
                    <span className={style.headline}>
                        {t("authentication.header")}
                    </span>

                    <div className={style.inputBlock}>
                        <label className={style.inputLabel}>
                            <div className={style.inputSvgBlock}>
                                <img
                                    src="/static/images/svg/email.svg"
                                    alt=""
                                />
                            </div>
                            {/* <img src="/static/images/svg/email.svg" alt="" /> */}
                            <input
                                className={style.input}
                                type="text"
                                value={email}
                                placeholder="Email"
                                onInput={(e) => setEmail(e.target.value)}
                            />
                        </label>

                        <label className={style.inputLabel}>
                            <div className={style.inputSvgBlock}>
                                <img src="/static/images/svg/key.svg" alt="" />
                            </div>
                            <input
                                className={style.input}
                                type="password"
                                value={password}
                                placeholder={t("authentication.password")}
                                onInput={(e) => setPassword(e.target.value)}
                            />
                        </label>
                    </div>

                    <button
                        className={style.button}
                        onClick={handleButtonClick}
                    >
                        {t("authentication.login_button")}
                    </button>
                    <Link
                        to={"/reset-password"}
                        className="mt-4 text-2xs text-gray-600 cursor-pointer"
                    >
                        {t("authentication.reset_password_link")}
                    </Link>
                    <Link
                        onClick={redirectToRegistration}
                        className="mt-2 text-2xs text-gray-600 cursor-pointer"
                    >
                        {t("authentication.registration_link")}
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default AuthenticationPage;
